import "./article_unitpage.css";
import language from "#scripts/translation";

export const articleUnitpage = (article) => {
	return `
    <div class="row justify-content-md-center">
      <div class='col-md-12'>${article.mainImage}</div>
        <div class="col-md-10 col-lg-7">
          <article class="article__main ml-md-4">
            <h1 class="article__header">${article.title}</h1>
              ${
								article.parsedIntro.length > 2
									? `<div class="article__intro">${article.parsedIntro}</div>`
									: ""
							}           
            <div class="article__content">
                ${article.content}
            </div>
          </article>
      </div>
      ${
				article.hasRightColumn
					? `<div class="col-md-10 col-lg-4 offset-lg-1">${article.rightColumn}</div>`
					: ""
			}
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 col-lg-7">
        <div class=" ml-lg-4">
          <p>
            ${
							article.created !== ""
								? `<span class="article__datetext article__datetext__date article__datetext__date-created"><span class="article__datetext__label">${language(
										"ARTICLE_PUBLISHED",
									)}</span> ${article.created}</span><br/>`
								: ""
						}
            ${
							article.published !== ""
								? `<span class="article__datetext article__datetext__date article__datetext__date-published"><span class="article__datetext__label">${language(
										"ARTICLE_MODIFIED",
									)}</span> ${article.published}</span>`
								: ""
						}
          </p>
        </div>
      </div>
      ${
				article.hasRightColumn ? '<div class="col-sm-4 offset-sm-1"></div>' : ""
			}
    </div>`;
};
